import React from "react";
import { Container } from "react-bootstrap";
import classNames from "classnames";
import NavBar from "../content/Navbar";
import AppRoutes from "../Routers/Routes";

const Navbar = (props) => {
  return (
    <Container
      fluid
      className={classNames("content", { "is-open": props.isOpen })}
    >

      <NavBar toggle={props.toggle} />
      <AppRoutes />
    </Container>
  );
};

export default Navbar;
